<div id="lock-info-popover">
  <p data-cy="lock-info-text">
    {{ 'i18n.menuProfitPro.createModal.lockIndicatorInfo' | translate }}
  </p>
</div>
